module.exports = __webpack_public_path__ + "static/media/odd.da410931.png";